<template>
	<div class="group1_R w_50">
		<!-- group1_R -->
		<ul class="title1">
			<li class="L">实时热词</li>
			<li class="M"></li>
			<!-- <li class="R"><a href="" class="more3">更多</a></li> -->
		</ul>
		<div class="hotwords">
			<div id="chartreci" style="width: 100%;height: 100%;"></div>
			<!-- <div style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;"></div> -->
		</div>
		<!-- <div  class="hotwords"><img src="images/hotwords.jpg" width="100%" height="100%"  alt=""/></div> -->
	</div><!-- /group1_R -->
</template>

<script>
	export default {
		data() {
			return {
				cloudchart: '',
				cloudwords: [],
			}
		},
		created: function() {

		},
		mounted: function() {
			this.getHotwords();
			// this.cloudchartinit();
		},
		methods: {
			getHotwords:function(){
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'recommend/getLatestHotWords',
						responseType: 'json',
						params: {
							iPage:'1',
							pageSize:'20',
						},
					})
					.then(function(response) {
						var hotwords=response.data.data.data;
						_this.cloudwords=[];
						for(var i=0;i<hotwords.length;i++){
							_this.cloudwords.push({
								name:hotwords[i].wordname,
								value:hotwords[i].clicknum
							})
						}
						_this.cloudchartinit();
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			cloudchartinit: function() {
				// debugger
				this.cloudchart = this.$echarts.init(document.getElementById('chartreci'));
				var option = {
					// title: {
					// 	text: "热爱祖国",
					// 	x: "center"
					// },
					backgroundColor: "#fff",
					// tooltip: {
					//   // pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
					// },
					animation:false,
					series: [{
						type: 'wordCloud',

						// The shape of the "cloud" to draw. Can be any polar equation represented as a
						// callback function, or a keyword present. Available presents are circle (default),
						// cardioid (apple or heart shape curve, the most known polar equation), diamond (
						// alias of square), triangle-forward, triangle, (alias of triangle-upright, pentagon, and star.

						// shape: 'diamond',

						// Keep aspect ratio of maskImage or 1:1 for shapes
						// This option is supported from echarts-wordcloud@2.1.0
						keepAspect: false,

						// A silhouette image which the white area will be excluded from drawing texts.
						// The shape option will continue to apply as the shape of the cloud to grow.

						// maskImage: maskImage,

						// Folllowing left/top/width/height/right/bottom are used for positioning the word cloud
						// Default to be put in the center and has 75% x 80% size.

						left: 'center',
						top: 'center',
						width: '100%',
						height: '100%',
						right: null,
						bottom: null,

						// Text size range which the value in data will be mapped to.
						// Default to have minimum 12px and maximum 60px size.

						sizeRange: [12, 60],

						// Text rotation range and step in degree. Text will be rotated randomly in range [-90, 90] by rotationStep 45

						rotationRange: [0, 0],
						// rotationStep: 45,

						// size of the grid in pixels for marking the availability of the canvas
						// the larger the grid size, the bigger the gap between words.

						gridSize: 30,

						// set to true to allow word being draw partly outside of the canvas.
						// Allow word bigger than the size of the canvas to be drawn
						drawOutOfBound: false,

						// If perform layout animation.
						// NOTE disable it will lead to UI blocking when there is lots of words.
						layoutAnimation: true,

						// Global text style
						textStyle: {
							fontFamily: 'sans-serif',
							fontWeight: 'bold',
							// Color can be a callback function or a color string
							color: function() {
								// Random color
								// return 'rgb(' + [
								// 	Math.round(Math.random() * 160),
								// 	Math.round(Math.random() * 160),
								// 	Math.round(Math.random() * 160)
								// ].join(',') + ')';
								return 'rgba(' + [
									Math.round((Math.random() * 40)+169),
									26,
									45,
									(Math.random() * 6+4)/10
								].join(',') + ')';
							}
						},
						emphasis: {
							disabled:true
							// focus: 'none',

							// textStyle: {
							// 	textShadowBlur: 10,
							// 	textShadowColor: '#333'
							// }
						},
						data: this.cloudwords
					}]
				};
				this.cloudchart.setOption(option);
				this.cloudchart.on('click', function(params){
					var a = document.createElement('a');
					a.setAttribute('href', '/search'+(params.data.name?('/'+params.data.name):''));
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a);
				});
			}

		}
	}
</script>

<style>
</style>
